import React from 'react';
import Icon from '../../../components/AppIcon';

const VerificationStatisticsDashboard = ({ statistics, loading, onRefresh }) => {
  if (loading) {
    return (
      <div className="space-y-4">
        {[1, 2, 3, 4]?.map(i => (
          <div key={i} className="bg-card rounded-lg shadow-sm border border-border p-6 animate-pulse">
            <div className="h-4 bg-muted rounded w-1/2 mb-3"></div>
            <div className="h-8 bg-muted rounded w-3/4"></div>
          </div>
        ))}
      </div>
    );
  }

  const stats = [
    {
      label: 'Pending Verifications',
      value: statistics?.pendingVerifications || 0,
      icon: 'Clock',
      color: 'text-amber-500',
      bgColor: 'bg-amber-50 dark:bg-amber-900/20',
      description: 'Awaiting email confirmation'
    },
    {
      label: 'Failed Confirmations',
      value: statistics?.failedConfirmations || 0,
      icon: 'AlertCircle',
      color: 'text-red-500',
      bgColor: 'bg-red-50 dark:bg-red-900/20',
      description: 'Expired or invalid tokens'
    },
    {
      label: 'Manual Verifications Today',
      value: statistics?.manualVerificationsToday || 0,
      icon: 'UserCheck',
      color: 'text-green-500',
      bgColor: 'bg-green-50 dark:bg-green-900/20',
      description: 'Admin verified accounts'
    },
    {
      label: 'Emails Resent Today',
      value: statistics?.emailsResentToday || 0,
      icon: 'Mail',
      color: 'text-blue-500',
      bgColor: 'bg-blue-50 dark:bg-blue-900/20',
      description: 'Verification emails resent'
    },
    {
      label: 'Success Rate (30 days)',
      value: `${statistics?.successRate || 0}%`,
      icon: 'TrendingUp',
      color: 'text-purple-500',
      bgColor: 'bg-purple-50 dark:bg-purple-900/20',
      description: 'Email confirmation success'
    }
  ];

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between mb-2">
        <h3 className="text-lg font-semibold text-foreground">Verification Status</h3>
        <button
          onClick={onRefresh}
          className="text-muted-foreground hover:text-foreground transition-colors"
        >
          <Icon name="RefreshCw" size={16} />
        </button>
      </div>

      {stats?.map((stat, index) => (
        <div key={index} className="bg-card rounded-lg shadow-sm border border-border p-6">
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm font-medium text-muted-foreground">{stat?.label}</span>
            <div className={`w-10 h-10 rounded-full flex items-center justify-center ${stat?.bgColor}`}>
              <Icon name={stat?.icon} className={`w-5 h-5 ${stat?.color}`} />
            </div>
          </div>
          <p className="text-3xl font-bold text-foreground mb-1">{stat?.value}</p>
          <p className="text-xs text-muted-foreground">{stat?.description}</p>
        </div>
      ))}
    </div>
  );
};

export default VerificationStatisticsDashboard;
